import {create} from "zustand";
import {route} from "ziggy-js";

export const useModalStore = create((set) => ({
    // Модальное окно "Заявка на возврат, обмен или ремонт"
    refundsModalFlag: false,
    // Данные по заказу/заказам для оформления заявки на возврат
    refundsData: {},

    /**
     * Открыть модальное окно "Заявка на возврат, обмен или ремонт"
     */
    openRefundsModal: () => set({refundsModalFlag: true}),
    /**
     * Закрыть модальное окно "Заявка на возврат, обмен или ремонт"
     */
    closeRefundsModal: () => set({refundsModalFlag: false, refundsData: {}}),
    /**
     * Запрос данных по заказу/заказам для оформления заявки на возврат
     * @param order_id
     * @returns {Promise<void>}
     */
    fetchRefundsData: async (order_id = null) => {
        const {data} = await axios.post(route('getRefundsData'), {order_id: order_id});
        const {success = {}} = data;
        set({refundsData: {...success.data, order_id: order_id}});
    },
}));
